export default "__VITE_ASSET__Dsno2uEp__"